// removed by extract-text-webpack-plugin
module.exports = {"loading_screen":"loading_screen__3f1Uc"};


//////////////////
// WEBPACK FOOTER
// ./components/loading-screen/style.scss
// module id = pCTO
// module chunks = 13